import { reactive, ref } from 'vue'

export function useDisclosure() {
  const isOpen = ref(false)

  const toggle = () => (isOpen.value = !isOpen.value)
  const open = () => (isOpen.value = true)
  const close = () => (isOpen.value = false)

  return reactive({ isOpen, toggle, open, close })
}

export type Disclosure = ReturnType<typeof useDisclosure>
